import { Outlet, useParams } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { AgreementsCard } from '../../../components/agreements-card/agreements-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function BuildingAgreementsRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <AgreementsCard buildingId={buildingId} />
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
